import { styled, Box } from '@mui/material';

type AlignType = 'left' | 'right' | 'center' | 'stretch';

const alignMap = {
  left: 'flex-start',
  right: 'flex-end',
  center: 'center',
  stretch: 'space-between',
};

const ButtonGroup = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'align',
})<{ align?: AlignType }>(({ theme, align = 'right' }) => ({
  display: 'flex',
  alignItems: 'center',
  alignContent: 'center',
  gap: theme.spacing(theme.spacingSizes.sm),
  justifyContent: alignMap[align],
}));

export default ButtonGroup;
